var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconFamily24 = function SvgAIconFamily24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.07692,
    cy: 5.07692,
    r: 2.07692
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.07692,
    cy: 12,
    r: 2.07692
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0008,
    cy: 5.07692,
    r: 2.07692
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0008,
    cy: 12,
    r: 2.07692
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.07692,
    cy: 18.9231,
    r: 2.07692
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0008,
    cy: 18.9231,
    r: 2.07692
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.9226,
    cy: 5.07692,
    r: 2.07692
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.9226,
    cy: 12,
    r: 2.07692
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.9226,
    cy: 18.9231,
    r: 2.07692
  })));
};
export { SvgAIconFamily24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJjdXJyZW50Q29sb3IiPgo8Y2lyY2xlIGN4PSI1LjA3NjkyIiBjeT0iNS4wNzY5MiIgcj0iMi4wNzY5MiIgLz4KPGNpcmNsZSBjeD0iNS4wNzY5MiIgY3k9IjEyIiByPSIyLjA3NjkyIiAvPgo8Y2lyY2xlIGN4PSIxMi4wMDA4IiBjeT0iNS4wNzY5MiIgcj0iMi4wNzY5MiIgLz4KPGNpcmNsZSBjeD0iMTIuMDAwOCIgY3k9IjEyIiByPSIyLjA3NjkyIiAvPgo8Y2lyY2xlIGN4PSI1LjA3NjkyIiBjeT0iMTguOTIzMSIgcj0iMi4wNzY5MiIgLz4KPGNpcmNsZSBjeD0iMTIuMDAwOCIgY3k9IjE4LjkyMzEiIHI9IjIuMDc2OTIiIC8+CjxjaXJjbGUgY3g9IjE4LjkyMjYiIGN5PSI1LjA3NjkyIiByPSIyLjA3NjkyIiAvPgo8Y2lyY2xlIGN4PSIxOC45MjI2IiBjeT0iMTIiIHI9IjIuMDc2OTIiIC8+CjxjaXJjbGUgY3g9IjE4LjkyMjYiIGN5PSIxOC45MjMxIiByPSIyLjA3NjkyIiAvPgo8L3N2Zz4=";